import {Kind, SelectionNode} from 'query-api-graphql';

/** package */
export const MAX_NUM_QUERY_API_FIELDS = 100;

/** package */
export const DEFAULT_FIELD = 'name';

/** package */
export const DEFAULT_FIELD_SELECTION: SelectionNode = {
  kind: Kind.FIELD,
  name: {
    kind: Kind.NAME,
    value: DEFAULT_FIELD,
  },
};

/**
 * Logical depth limit for the registry schema field selector form
 * @package
 */
export const ENTITY_SCHEMA_FIELD_SELECTOR_LOGICAL_DEPTH_LIMIT = 4;

/**
 * Subtract one from the overall limit because backlink (result-join) fields are one level deep into the
 * query.
 * @package
 */
export const RESULT_SCHEMA_FIELD_SELECTOR_LOGICAL_DEPTH_LIMIT =
  ENTITY_SCHEMA_FIELD_SELECTOR_LOGICAL_DEPTH_LIMIT - 1;

/**
 * Logical depth limit for the plate schema field selector form
 * @package
 */
export const PLATE_SCHEMA_FIELD_SELECTOR_LOGICAL_DEPTH_LIMIT = 6;

/** @package */
export const FORM_STATE_THROTTLE_DURATION = 1000;

/**
 * Not used by frontend except for messaging.
 *
 * Keep in sync with benchling/v3_api/query_api/datasets/dataset_builder.py
 *
 * @package
 */
export const PREVIEW_LIMIT = 100;
